import { ORDER_ACTION_TYPE } from '@/api/type/commonTypes';
import { GetOrderDetailResponse } from '@/api/type/types';
import { Images } from '@/assets';
import { formatPartnerAlarmMsg } from '@/utils/alarm-message/formatPartnerAlarmMessage';
import { formatDateHHMM } from '@/utils/date-time/formatDateHHMM';
import { formatName } from '@/utils/name/formatName';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface OrderLogProps {
  orderDetail: GetOrderDetailResponse;
}
const OrderLog = ({ orderDetail }: OrderLogProps) => {
  const { i18n, t } = useTranslation();
  return (
    <Container>
      <TitleSection>
        <Img src={Images.OrderLogIcon} alt="order-log-icon" />
        <Title>{t('workLog')}</Title>
      </TitleSection>
      <Box>
        {orderDetail.history.map((item) => (
          <div key={item.id}>
            {formatPartnerAlarmMsg(item.type, t)} By {item.loginId} /{' '}
            {formatName({
              countryCode: item.name.countryCode,
              firstName: item.name.firstName,
              lastName: item.name.lastName,
            })}{' '}
            [{formatDateHHMM(item.actionAt, i18n.language)}]
          </div>
        ))}
      </Box>
    </Container>
  );
};

export default OrderLog;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Img = styled.img`
  width: 21px;
  height: 21px;
`;

const Title = styled.div`
  font-size: 14px;
  line-height: 120%;
  color: #769bf7;
`;

const Box = styled.div`
  margin: 1px;
  padding: 9px 12px;
  background: #fff;
  box-shadow: 0px 0px 4px rgba(91, 75, 232, 0.25);
  font-size: 12px;
  line-height: 120%;
  color: #000000;
  height: 158.14px;
  box-sizing: border-box;
  border-radius: 10px;
  overflow-y: auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
